export default function Architecture() {
  return <div>Architecture Project Page</div>;
}

